import BaseComponent from '../base/baseComponent';
import customEventBus from '../libs/eventBus';
import a11yUtils from '../utilities/a11yUtils';
import keyboardUtils from '../utilities/keyboardUtils';
export default class RefinementsTrigger extends BaseComponent {
    get SELECTORS() {
        return {
            refinementsWrapper: '.refinements--wrapper',
            refinementsCta: '.toolbar-container .toolbar-cta--refinements',
            toolbar: '.plp-page .toolbar',
        };
    }
    get CLASSES() {
        return {
            open: 'open',
            refinementsCta: 'toolbar-cta--refinements',
            filterOpen: 'filter-open'
        };
    }
    constructor(element) {
        super(element);
        customEventBus.on('sorting:trigger', (data) => {
            this.hideFiltersWrapper();
        });
        this.handleClick();
        this.handleKeyDown();
    }
    handleClick() {
        const refinementsWrapper = document.querySelector(this.SELECTORS.refinementsWrapper);
        const toolbar = document.querySelector(this.SELECTORS.toolbar);
        document.querySelector('body').addEventListener('click', (e) => {
            if (!e.target.closest('#refinements-wrapper') && !e.target.closest('#sorting-wrapper') && !e.target.classList.contains('toolbar-cta--refinements') && !e.target.classList.contains('toolbar-cta--sorting') && !e.target.closest('.toolbar-cta--refinements') && !e.target.closest('.toolbar-cta--sorting')) {
                this.closeRefinements(toolbar, refinementsWrapper);
            }
        });
        this._el.addEventListener('click', (e) => {
            this.toggleRefinements(toolbar, refinementsWrapper);
        });
    }
    closeRefinements(toolbar, refinementsWrapper) {
        this._el.classList.remove(this.CLASSES.open);
        if (toolbar) {
            toolbar.classList.remove(this.CLASSES.filterOpen);
        }
        let refinementsCta = document.querySelector(this.SELECTORS.refinementsCta);
        if (refinementsCta) {
            refinementsCta.classList.remove(this.CLASSES.open);
        }
        if (refinementsWrapper) {
            refinementsWrapper.classList.remove(this.CLASSES.open);
        }
        a11yUtils.focusTrapOff();
    }
    toggleRefinements(toolbar, refinementsWrapper) {
        customEventBus.emit('filter:trigger', {});
        this._el.classList.toggle(this.CLASSES.open);
        if (toolbar) {
            toolbar.classList.toggle(this.CLASSES.filterOpen);
        }
        if (!this._el.classList.contains(this.CLASSES.refinementsCta)) {
            let refinementsCta = document.querySelector(this.SELECTORS.refinementsCta);
            if (refinementsCta) {
                refinementsCta.classList.toggle(this.CLASSES.open);
            }
        }
        if (refinementsWrapper) {
            refinementsWrapper.classList.toggle(this.CLASSES.open);
            if (this._el.classList.contains(this.CLASSES.open)) {
                a11yUtils.focusTrapOn(refinementsWrapper);
                refinementsWrapper.focus();
            }
            else {
                a11yUtils.focusTrapOff();
            }
        }
    }
    handleKeyDown() {
        const refinementsWrapper = document.querySelector(this.SELECTORS.refinementsWrapper);
        const toolbar = document.querySelector(this.SELECTORS.toolbar);
        if (refinementsWrapper) {
            refinementsWrapper.addEventListener('keydown', (e) => {
                if (keyboardUtils.isEscKey(e)) {
                    e.preventDefault();
                    this.closeRefinements(toolbar, refinementsWrapper);
                }
            });
        }
    }
    hideFiltersWrapper() {
        const refinementsWrapper = document.querySelector(this.SELECTORS.refinementsWrapper);
        const toolbar = document.querySelector(this.SELECTORS.toolbar);
        this._el.classList.remove(this.CLASSES.open);
        toolbar.classList.remove(this.CLASSES.filterOpen);
        refinementsWrapper.classList.remove(this.CLASSES.open);
    }
}
